import styled from 'styled-components';

const VideoContainer = styled.div`
    background-color: #e3e5e4;
`;

export  { VideoContainer } ;